import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProdutoFidelidade } from 'src/app/models/produto-fidelidade';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FidelidadeProdutoService } from 'src/app/services/fidelidade-produto.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';

// jquery
declare const $: any;

@Component({
  selector: 'app-cadastrar-produto-fidelidade-modal',
  templateUrl: './cadastrar-produto-fidelidade-modal.component.html',
  styleUrls: ['./cadastrar-produto-fidelidade-modal.component.scss']
})
export class CadastrarProdutoFidelidadeModalComponent implements OnInit {


  idProduto;
  produto: ProdutoFidelidade;
  public config: PerfectScrollbarConfigInterface = {};
  administrador = false;
  carregando = true;
  editando = false;
  selectedFile: File;

  // construtor
  constructor(public dialogRef: MatDialogRef<CadastrarProdutoFidelidadeModalComponent>, private globalService: GlobalService,
    @Inject(MAT_DIALOG_DATA) public data: any, private notificacaoService: NotificacaoService, private fidelidadeProdutoService: FidelidadeProdutoService,
    private spinner: NgxSpinnerService, private utilitarioService: UtilitarioService, private carregandoService: CarregandoService,) {
    this.idProduto = data.idProduto;
  }

  async ngOnInit() {

    this.administrador = await this.globalService.administrador();
    if (this.idProduto) {
      this.editando = true;
      this.buscarProdutoFidelidade();
    } else {
      this.produto = new ProdutoFidelidade();
      this.produto.ativo = true;
    }

    // this.valorTotal = this.data.valorTotal;
    // this.item.valor = this.utilitarioService.formataNumero(this.item.valor);
  }

  async salvar() {
    if (this.selectedFile) {
      this.produto.fotoBase64 = (await this.utilitarioService.toBase64(this.selectedFile));
    }
    if (this.produto.pontos !== null && this.produto.pontos !== undefined) {
      this.produto.pontos = Number(this.produto.pontos);
    }
    if (this.produto.prazoEntrega !== null && this.produto.prazoEntrega !== undefined) {
      this.produto.prazoEntrega = Number(this.produto.prazoEntrega);
    }
    this.carregandoService.mostra('salvarProdutoFidelidade');
    this.fidelidadeProdutoService.salvar(this.produto).subscribe((retorno) => {
      this.notificacaoService.sucesso('Produto salvo com sucesso!!!');
      this.carregandoService.esconde('salvarProdutoFidelidade');
      this.dialogRef.close(true);
    }, (erro) => {
      this.carregandoService.esconde('salvarProdutoFidelidade');
      this.notificacaoService.erro(erro);
    });

  }


  fechar() {
    this.dialogRef.close();
  }

  buscarProdutoFidelidade() {
    this.carregandoService.mostra('buscarProdutoFidelidade');

    this.fidelidadeProdutoService.consultarPorId(this.idProduto).subscribe((data: any) => {
      this.produto = data;

      this.carregando = false;
      this.carregandoService.esconde('buscarProdutoFidelidade');
    }, (erro) => {
      this.carregandoService.esconde('buscarProdutoFidelidade');
      this.notificacaoService.erro(erro);
    });
  }

  onFileChanged(event) {
    this.produto.foto = '';
    this.selectedFile = event.target.files[0];
  }

  excluirArquivo() {
    this.selectedFile = undefined;
    this.produto.foto = '';
    this.produto.fotoBase64 = '';
  }

  validar() {
    return this.produto.produto !== null && this.produto.produto !== undefined &&
      this.produto.prazoEntrega !== null && this.produto.prazoEntrega !== undefined &&
      this.produto.pontos !== null && this.produto.pontos !== undefined;
  }
}
